import { put, takeEvery } from 'redux-saga/effects';

import { UserAction } from '../actions';
import { UserConstant } from '../constants';

export default function* () {
  yield takeEvery(
    [UserConstant.CREATE_USER_SUCCESS, UserConstant.EDIT_USER_SUCCESS],
    createOrEditUserSuccess,
  );
  yield takeEvery(UserConstant.DELETE_USER_SUCCESS, deleteUserSuccess);
  yield takeEvery(UserConstant.GET_USERS_SUCCESS, getUsersSuccess);
  yield takeEvery(UserConstant.GET_USER_SUCCESS, getUserSuccess);
}

function* createOrEditUserSuccess() {
  yield put(UserAction.setUser({}));
}

function* deleteUserSuccess() {
  yield put(UserAction.getUsers());
}

function* getUsersSuccess(action) {
  yield put(UserAction.setUsers(action?.payload));
}

function* getUserSuccess(action) {
  yield put(UserAction.setUser(action?.payload));
}
